////////////////////////////////////////////////
// Define variables for project
////////////////////////////////////////////////
const vars = {};

vars.location = window.location;
vars.url = window.location.href;
vars.winWidth = window.innerWidth;
vars.body = document.querySelector('body');

const log = variable => console.log(variable);

export { vars, log }